import React, { CSSProperties } from "react";
import { Controller, ControllerProps } from "react-hook-form";
import { sanitizeDecimalInput } from "src/utils/numericInput";
import TextField from "../TextField";

function TextFieldController({
  control,
  name,
  rules,
  fieldValue,
  as,
  label,
  dataCy,
  className,
  eyeIcon,
  type,
  disabled,
  style = {},
  formText = "",
  maxLength,
  min,
  inputMode,
  decimalInput,
  ...rest
}: TextFieldControllerPropsType) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        let displayValue;

        if (decimalInput) {
          const raw = value ?? fieldValue ?? "";
          displayValue = sanitizeDecimalInput(String(raw));
        } else if (typeof value === "string") {
          displayValue = value.trim() !== "" ? value : fieldValue;
        } else {
          displayValue = value || fieldValue;
        }

        return (
          <TextField

            value={displayValue}
            onChange={(next) => onChange(decimalInput ? sanitizeDecimalInput(String(next ?? "")) : next)}
            label={label}
            as={as as any}
            error={error?.message}
            className={className}
            dataCy={dataCy || name}
            eyeIcon={eyeIcon}
            type={type}
            disabled={disabled}
            style={style}
            formText={formText}
            maxLength={maxLength}
            min={min}
            inputMode={inputMode}
            decimalInput={decimalInput}
          />
        );
      }}
      {...rest}
    />
  );
}

type TextFieldControllerPropsType = Omit<ControllerProps, "render"> & {
  label: string;
  dataCy?: string;
  fieldValue?: string | number;
  as?: string;
  className?: string;
  eyeIcon?: boolean;
  type?: inputType;
  style?: CSSProperties;
  formText?: string;
  maxLength?: number;
  min?: number;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  decimalInput?: boolean;
};

export default TextFieldController;
